import SelectCultivation from 'assets/images/farm/select-cultivation/select-cultivation.svg';
import {useNavigate} from 'react-router-dom';
import {TARGET_URL} from 'services/config';
import useGetListFarms from 'utilities/hooks/listFarms';
const NoCultivation = () => {
  const {listFarms} = useGetListFarms();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col pb-12">
      <img
        alt="select-cultivation"
        src={SelectCultivation}
        className=" block mx-auto w-2/3 mt-24"
      />
      <p className=" font-extrabold text-gray-6 text-lg ">
        هنوز کشت ثبت نکردید؟
      </p>
      <p className=" text-gray-6 mt-4 pl-6">
        برای ثبت آگهی فروش لازم است ابتدا کشت مزرعه خود را ثبت کرده و سپس محصول
        را به فروش بگذارید
      </p>
      <button
        className=" w-full py-4 mt-10 text-white bg-primary rounded-lg "
        onClick={() => {
          if (listFarms && listFarms.results.length === 1) {
            window.location.replace(
              `${TARGET_URL}cultivation/addInputGroup/${listFarms.results[0].guid}`,
            );
          } else {
            navigate('/farm/add-ad/list-farms');
          }
        }}
      >
        افزودن کشت
      </button>
    </div>
  );
};

export default NoCultivation;
